import * as types from '../../mutation-types'
import axios from "axios";

export const fetchShopProducts = async ({commit}, productId = '') => {
    try {
        let url = process.env.API_URL + '/get-shop/products'

        if (productId) {
            url = url + '/' + productId
        }

        const {data} = await axios.get(url)
        commit(types.FETCH_SHOP_PRODUCTS_SUCCESS, data)
    } catch (e) {
        commit(types.FETCH_SHOP_PRODUCTS_FAILURE)
    }
};

export const fetchBlog = async ({commit}) => {
    try {
        const {data} = await axios.get(process.env.API_URL + '/get-blog')
        commit(types.FETCH_BLOG_SUCCESS, data)
    } catch (e) {
        commit(types.FETCH_BLOG_FAILURE)
    }
};

export const saveProductsLog = async ({commit}, formData) => {
    console.log('saveProductLog', formData)
    await axios.post(process.env.API_URL + '/save-products-log', formData);
}

export const fetchProductsLog = async ({commit}, formData) => {
    try {
        const {data} = await axios.get(process.env.API_URL + '/get-products-log/' + formData.userId)
        commit(types.FETCH_PRODUCTS_LOG_SUCCESS, data)
    } catch (e) {
        commit(types.FETCH_PRODUCTS_LOG_FAILURE)
    }
};

export const createOrder = async ({commit}, formData) => {
    await axios.post(process.env.API_URL + '/create-order', formData);
}

export const cartUpdate = ({commit}, data) => {
    commit(types.CART_UPDATE, data)
}


// WEBPACK FOOTER //
// ./src/store/modules/squarespace/actions.js